import Cookies from "js-cookie";
import { throttle } from "lodash";
import { getIdToken } from "./auth/utils";

type UserEvent = "forceTokenRefresh";

const listeners: Record<UserEvent, (() => void)[]> = {
  forceTokenRefresh: [],
};

export const userEvents = {
  on(event: UserEvent, cb: () => Promise<void>) {
    listeners[event].push(cb);
  },
  emit(event: UserEvent) {
    listeners[event].forEach((cb) => cb());
  },
  off(event: UserEvent, cb: () => void) {
    listeners[event] = listeners[event].filter((c) => c !== cb);
  },
  clear(event: UserEvent) {
    listeners[event] = [];
  },
};

export const throttledForceTokenRefresh = throttle(
  async () => {
    const idToken = await getIdToken(true);
    if (idToken) {
      Cookies.set("jwt", idToken);
      userEvents.emit("forceTokenRefresh");
    }
  },
  10000,
  { leading: true, trailing: false }
);
